// @flow
import Dishes2MenuForm from './Dishes2MenuForm';

export default Dishes2MenuForm;
